export const getYesOrNoTextByBoolean = (value?: boolean) => {
  if (typeof value !== 'boolean') {
    return ''
  }

  return value ? 'Sim' : 'Não'
}
